<template>
  <div class="home-layout">
    <div class="col-1">
        <Menu :model="items">
          <template #item="{ item, props }">
            <RouterLink v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
              <a :href="href" v-bind="props.action" @click="navigate">
                <span style="margin-right: 5px;" :class="item.icon" />
                <span>{{ item.label }}</span>
              </a>
            </RouterLink>
          </template>
        </Menu>
    </div>
    <div class="col-2">
      <router-view name="col2" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const items = ref([
  { label: 'Home', icon: 'pi pi-home', route: '/home' },
  { label: 'Starred', icon: 'pi pi-star', route: '/home/starred' },
]);



</script>

<style scoped lang="scss">
.home-layout {
  display: flex;
  flex-basis: 100%;
  margin: 32px;
  height: 100vh;

  .col-1 {
    flex-direction: column;
    display: flex;
    max-width: 240px;
    padding-right: 20px;
    width: 100%;

  }

  .col-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1152px;
    width: 100%;
    margin-left: 50px;


  }
}


</style>
